export enum LawInterfacesEnum {
  FZ_248 = '248ФЗ',
  FZ_294 = '294ФЗ',
}
